.blue {
  color: var(--ds-blue);
}

.blue-lighter {
  color: var(--ds-blue-lighter);
}

.blue-light {
  color: var(--ds-blue-light);
}

.blue-light-hover {
  color: var(--ds-blue-light-hover);
}

.blue-dark {
  color: var(--ds-blue-dark);
}

.blue-dark-hover {
  color: var(--ds-blue-dark-hover);
}

.mauve {
  color: var(--ds-mauve);
}

.green-money-in {
  color: var(--ds-green-money-in);
}

.white {
  color: var(--ds-white);
}

.off-white {
  color: var(--ds-off-white);
}

.off-white-darker {
  color: var(--ds-off-white-dark);
}

.pearl-grey {
  color: var(--ds-pearl-grey);
}

.pearl-grey-medium {
  color: var(--ds-pearl-grey-medium);
}

.pearl-grey-dark {
  color: var(--ds-pearl-grey-dark);
}

.pearl-grey-darker {
  color: var(--ds-pearl-grey-darker);
}

.pearl-grey-darkest {
  color: var(--ds-pearl-grey-darkest);
}

.grey {
  color: var(--ds-grey);
}

.grey-medium {
  color: var(--ds-grey-medium);
}

.grey-dark {
  color: var(--ds-grey-dark);
}

.black {
  color: var(--ds-black);
}

.green-dark {
  color: var(--ds-green-dark);
}

.green-light {
  color: var(--ds-green-light);
}

.green {
  color: var(--ds-green);
}

.red-dark {
  color: var(--ds-red-dark);
}

.red-light {
  color: var(--ds-red-light);
}

.red {
  color: var(--ds-red);
}

.highlight {
  color: var(--ds-highlight);
}

.highlight-dark {
  color: var(--ds-highlight-dark);
}

.highlight-darker {
  color: var(--ds-highlight-darker);
}

.poker-green {
  color: var(--ds-poker-green);
}

.poker-green-darker {
  color: var(--ds-poker-green-darker);
}

.poker-green-lighter {
  color: var(--ds-poker-green-lighter);
}

/* Background colors */

.background-blue {
  background-color: var(--ds-blue);
}

.background-blue-light {
  background-color: var(--ds-blue-light);
}

.background-blue-light-hover {
  background-color: var(--ds-blue-light-hover);
}

.background-blue-dark {
  background-color: var(--ds-blue-dark);
}

.background-blue-dark-hover {
  background-color: var(--ds-blue-dark-hover);
}

.background-mauve {
  background-color: var(--ds-mauve);
}

.background-white {
  background-color: var(--ds-white);
}

.background-off-white {
  background-color: var(--ds-off-white);
}

.background-pearl-grey {
  background-color: var(--ds-pearl-grey);
}

.background-pearl-grey-dark {
  background-color: var(--ds-pearl-grey-dark);
}

.background-pearl-grey-darker {
  background-color: var(--ds-pearl-grey-darker);
}

.background-pearl-grey-darkest {
  background-color: var(--ds-pearl-grey-darkest);
}

.background-grey {
  background-color: var(--ds-grey);
}

.background-grey-medium {
  background-color: var(--ds-grey-medium);
}

.background-grey-dark {
  background-color: var(--ds-grey-dark);
}

.background-black {
  background-color: var(--ds-black);
}

.background-green-dark {
  background-color: var(--ds-green-dark);
}

.background-green-light {
  background-color: var(--ds-green-light);
}

.background-green {
  background-color: var(--ds-green);
}

.background-red-dark {
  background-color: var(--ds-red-dark);
}

.background-red-light {
  background-color: var(--ds-red-light);
}

.background-red {
  background-color: var(--ds-red);
}

.background-highlight-darker {
  background-color: var(--ds-highlight-darker);
}

.background-highlight {
  background-color: var(--ds-highlight);
}

.background-poker-green {
  background-color: var(--ds-poker-green);
}

.background-poker-green-darker {
  background-color: var(--ds-poker-green-darker);
}

.background-poker-green-lighter {
  background-color: var(--ds-poker-green-lighter);
}
